import { Injectable } from '@angular/core';

export enum LocalStorageKeyOptions {
  CurrentUser = "currentUser",
  Token = "token",
  Expiration = "expiration",
  Privileges = "privileges",
  RefreshToken = "refreshToken"
}


@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  setItem(key: LocalStorageKeyOptions, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: LocalStorageKeyOptions): any {
    return JSON.parse(localStorage.getItem(key));
  }

}
